import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { MainNavigation as BaseNavigation } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useFlipperKey from '@hooks/useFlipperKey'
import useMainNavigation from '@hooks/useMainNavigation'

import systemBrandPayload from '@components/systemBrands/default'
import generateMainNavigationItems from '@sections/Admin/utils/generateMainNavigationItems'
import useIntercom from '@hooks/useIntercom'

interface MainNavigationProps {
  minimized?: boolean,
  nestedNavigation?: React.ReactNode,
}

const MainNavigation = (props: MainNavigationProps) => {
  const { minimized, nestedNavigation } = props

  const {
    isTeamLead,
    teamsWhereTeamLeadIds,
    isAdmin,
    isBrandUser,
    isProviderDirector
  } = useCurrentUser()

  const { isEnabled: canvaTemplatesEnabled } = useFlipperKey('canva_templates')

  const navigationItems = useMemo(
    () => generateMainNavigationItems({
      isTeamLead,
      isAdmin,
      isBrandUser,
      isProviderDirector,
      teamsWhereTeamLeadIds,
      canvaTemplatesEnabled,
    }), [isTeamLead, canvaTemplatesEnabled, isAdmin, isBrandUser, isProviderDirector],
  )

  const { callbacks: { toggleNavigation }, showNavigation } = useMainNavigation()
  const canUseIntercom = isAdmin || isBrandUser || isProviderDirector

  useIntercom({ hideWidget: !canUseIntercom })
  return (
    <BaseNavigation
      // @ts-expect-error TS2322
      callbacks={{ toggleSidebar: toggleNavigation }}
      minimized={!!minimized}
      // @ts-expect-error TS2322
      navigationItems={navigationItems}
      nestedNavigation={nestedNavigation}
      nestedNavigationWidth={240}
      showNavigation={showNavigation}
      // @ts-expect-error TS2322
      systemBrandPayload={systemBrandPayload}
    />
  )
}

MainNavigation.propTypes = {
  minimized: PropTypes.bool,
  nestedNavigation: PropTypes.node,
}

export default MainNavigation
